import { FloatingInput } from '@/components/ui/floating-input';
import {
  TransactionBuilderParameterInputProps,
  TransactionBuilderParameterState,
} from './types';
import { getParameterStateForGenericInput } from './utils';
import { getReadableSolidityName } from '@/lib/solidity-formatting';

export function GenericInput({
  value,
  name,
  onChange,
  paramAbiFragment,
  isValid,
}: TransactionBuilderParameterInputProps): React.ReactElement {
  const label = getReadableSolidityName(
    paramAbiFragment.name || name,
    'Parameter'
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Update form state
    const newState: TransactionBuilderParameterState =
      getParameterStateForGenericInput(event.target.value);
    // Call `onChange` callback
    onChange?.(name, newState);
  };

  return (
    <div className="flex flex-col gap-1 w-full">
      <FloatingInput
        value={value}
        onChange={handleChange}
        label={label}
        placeholder="Enter value"
        className={!isValid ? 'border-red-500 focus-visible:ring-red-500' : ''}
      />
      {/* Only way for it to be invalid is to be empty */}
      {!isValid && <p className="text-xs text-red-500 px-1">Cannot be empty</p>}
    </div>
  );
}
